import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip } from 'rxjs'
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { element } from 'protractor';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}
@Component({
  selector: 'app-multicapture-bank-details',
  templateUrl: './multicapture-bank-details.component.html',
  styleUrls: ['./multicapture-bank-details.component.scss']
})
export class MulticaptureBankDetailsComponent implements OnInit {
  _currentComponentName = 'MulticaptureBankDetailsComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private message: NzMessageService,
    public appMetadataHandler: AppMetadataHandler) { }

  //Declaraions which might need developer input
  multiBankDetailsForm: FormGroup
  MULTIBANKDETAILS = "multiBankDetailsForm"
  lookupsToBind = ['paymentMethodCd','AccountPurpose']
  selectorOfThisComponent = 'app-multicapture-bank-details'
  parentEvent$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() IO: any;
  @Input() transactionState: string;
  private _inputDataForEdit = null;
  @Input() bankBeneficiaryRole: string;
  clientList: any;
  multiCaptureBankDetails = {};
  @Input() smartUIConfig;
  extractedSmartUIConfig = {};

  @Input()
  set inputDataForEdit(value: any) {
    console.log("multi bank capture comp input value", JSON.stringify(value));
    this._inputDataForEdit = value;

    if (this.transactionState === 'proposal_DataEntry')
      this.payeeList = this.commonUtilty.searchAndStitchClientDOForPayer(this._inputDataForEdit, this.IO)
    else
      this.payeeList = this.commonUtilty.searchAndStitchClientDO(this._inputDataForEdit, this.IO)
    console.log("payee list", JSON.stringify(this.payeeList));
    this.subscribeToAllBankChildren(this.payeeList);
    console.log("list of payee getting added at line No.78: ",this.payeeList)
  };

  private _policyData
  @Input()
  set policyData(value: any) {
    if (!value)
      this._policyData = {}
    else
      this._policyData = value
  }

  get policyData() {
    return this._policyData;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let isOutputValid = this.validateOutput(this.multiBankDetailsForm)
        if (isOutputValid)
          this.askAllChildrenForData();
        else {
          this.EmitComponentOutput("ERROR")
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }

  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  guid: any

  ngOnInit() {
    this.extractedSmartUIConfig = this.commonUtilty.extractSmartUIConfig(this.smartUIConfig);
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }

    this.multiCaptureBankDetails = {
      title: "No " + this.bankBeneficiaryRole + " Selected",
      message: "To add bank details, please go " + this.bankBeneficiaryRole + " section and Select atleast one Payee"
    }

    this.initializeMultiBankForm(this._inputDataForEdit)
    this.subscribeToParentEvent();
    this.subscribeToAddPayee();
    this.guid = this._extractCurrentGuid(this.IO)
    console.log("list of payees added",this.payeeList)
    this.filterPurposeList();
  }



  /**
   * Form Trasactions
   */

  initializeMultiBankForm(data?) {
    let payload = data || {}
    this.multiBankDetailsForm = this.fb.group({

    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.MULTIBANKDETAILS
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  findBankDetails() {

    let claims = this.getDO(this.policyData);
    this.clientList = this.getClinetDO(this.policyData) || [];
    //this.clientList=this.policyData['clientDOs'];

  }

  getDO(IO) {
    if (IO)
      return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'];
    else
      null
  }

  getClinetDO(IO) {
    let output: any;
    let DO = this.getDO(IO)
    if (DO != null && (IO['intimationDO'] || IO['claimDO'] || IO['proposalDO'] || IO['caseDO'])) {
      let clientDO = IO['clientDOs'];
      let clientRoles = IO['intimationDO']['claimClientRoles'] || IO['claimDO']['claimClientRoles']
        || IO['caseDO']['proposalClients'] || IO['proposalDO']['proposalClients'];
      let nomineeRef = clientRoles.find(item => {
        if (item)
          return item['roleCd'] === 'NOMINEE';
      }) || []

      output = clientDO.filter(item => {
        if (item)
          return item['guid'] === nomineeRef.clientRefGuid;
      }) || []
    }


    return output
  }

  _extractCurrentGuid(IO) {
    if (IO && IO.claimDO) {
      return IO.claimDO.guid
    }
    else if (IO && IO.intimationDO) {
      return IO.intimationDO.guid
    }
    else
      return null
  }


  payeeList: any = []
  payeeListSubject$
  subscribeToAddPayee() {
    if (this.payeeListSubject$)
      this.payeeListSubject$.unsubscribe()
    this.payeeListSubject$ = this.interactService.payeeListSubject$.subscribe(res => {
      if (res && Array.isArray(res)) {
        let refreshedPayeeList = this.commonUtilty.refreshPayeeList(this.payeeList, res);
        this.payeeList = this.commonUtilty.deepCopy(refreshedPayeeList)
        console.log("list of payee getting added at line No. 246: ", this.payeeList)
        this.filterPurposeList();
        this.subscribeToAllBankChildren(this.payeeList);
      }
    })
  }

  // for emit form instead of image
  askAllChildrenForData() {
    if (this.payeeList && Array.isArray(this.payeeList) && this.payeeList.length > 0)
      this.interactService.pingBankChildToReact(this.getCurrentComponentName())
    else {
      //No Payee Selected Scenario
      let emptyArray = []
      this.EmitComponentOutput(emptyArray)
    }
  }

  bankDetailsChildDataPipe: any = {};
  makeBankSubjects(clientList) {
    let ChildBankDataPipe = {}
    if (clientList && clientList.length && clientList.length > 0) {
      clientList.forEach(element => {
        let bankDetaisSubject = new Subject();
        if (element && element['clientDO'] && element['clientDO']['clientNum'])
          ChildBankDataPipe[element['clientDO']['clientNum']] = bankDetaisSubject;
        else if(element && element['clientDO'] && this.commonUtilty.isArrayIterable(element['clientDO']) && element['clientDO'].find(e=> true)['clientNum'])
        ChildBankDataPipe[element['clientDO'].find(e=> true)['clientNum']] = bankDetaisSubject;
      });
    }
    let keys = Object.keys(ChildBankDataPipe)
    if (clientList && clientList.length && clientList.length > 0 && keys.length != clientList.length && !environment.production) {
      // throw "Number of Client in Bank to Subjects Mismatch";
    }
    return ChildBankDataPipe
  }

  childrenDataPipeSubscription$
  subscribeToAllBankChildren(clientList) {
    this.bankDetailsChildDataPipe = this.makeBankSubjects(clientList)
    let dataPipeIterable = this.convertDataPipeObjectToArray(this.bankDetailsChildDataPipe)
    if (this.childrenDataPipeSubscription$ != null) this.childrenDataPipeSubscription$.unsubscribe()
    this.childrenDataPipeSubscription$ = zip(...dataPipeIterable).subscribe(responses => {
      if (Object.keys(this.emitterHistory).length === this.getChildrenNumber()) {
        let dataToEmit = this.extractComponentDataFromComponentDataList(responses)
        this.EmitComponentOutput(dataToEmit)
      }
      else {
        if (!environment.production) {
          throw `Zip Output mismatch in ${this.getCurrentComponentName()} placed in ${this.getParentComponentName()}`;
        }
        else {
          console.log(`Zip Output mismatch in ${this.getCurrentComponentName()} placed in ${this.getParentComponentName()}`)
        }
      }

    })
  }

  extractComponentDataFromComponentDataList(componentOutputList) {
    let output = []
    let errorOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }

    let isInvalid = false;
    componentOutputList.forEach(componentOutput => {
      if (componentOutput.componentData.isInvalid) {
        isInvalid = componentOutput.componentData['isInvalid']
        errorOutput.isInvalid = true;
        errorOutput.errorDOs.push(...componentOutput.componentData.errorDOs)
      }
      if (!isInvalid) {
        output.push(this.commonUtilty.deepCopy(componentOutput.componentData))
      }
    });

    if (isInvalid)
      return errorOutput
    else
      return output
  }

  convertDataPipeObjectToArray(dataPipe) {
    let childrenSubscribers$ = []
    if (dataPipe) {
      let clients = dataPipe
      for (const key in clients) {
        if (clients.hasOwnProperty(key)) {
          childrenSubscribers$.push(clients[key]);
        }
      }
    }
    if (childrenSubscribers$.length == Object.keys(dataPipe).length)
      return childrenSubscribers$
    else
      throw new Error("Number of Subject Mappers Do not Match Number of childrenSubscribers")
  }

  emitterHistory = {}
  _BaseEmitHandler(data, clientNum) {
    console.log("MultiBankBaseEmitHandler Fired For " + clientNum)
    this.emitterHistory[clientNum] = data
    if (this.bankDetailsChildDataPipe && clientNum && this.bankDetailsChildDataPipe[clientNum]) {
      this.bankDetailsChildDataPipe[clientNum].next(data);
    }
    if (Object.keys(this.emitterHistory).length === this.getChildrenNumber()) {
      console.log("All Children Banks emitted data")
      console.log(this.emitterHistory)
    }
  }

  getChildrenNumber() {
    let count = null
    if (this.bankDetailsChildDataPipe) {
      let c = Object.keys(this.bankDetailsChildDataPipe)
      count = c.length
    }
    return count
  }

  /**
   * Below code is temporary added for demo to show multi bank option for single payer. This code needs to be corrected for implementation.
   */
  enableSpecificBankTab: number = 0;
  bankDataList = [{
    'bankFormPurpose': []
  }];

  addNewBankForm(){
    this.bankDataList.push({
      'bankFormPurpose': []
    });
    this.enableSpecificBankTab = this.bankDataList.length - 1;
  }
  /**
   * END: ABOVE code is temporary added for demo to show multi bank option for single payer. This code needs to be corrected for implementation.
   */

  updateBankPurpose(event,index) {
    let selectedPurpose = []
    let completeBankPurposeList = this.commonUtilty.deepCopy(this.bankPurposeCd); // get complete lookup in a variable to splice and assign the unselected value.
    if (this.bankDataList && Array.isArray(this.bankDataList)) {
      this.bankDataList.forEach(bank => {
        selectedPurpose.push(...bank.bankFormPurpose)
      })
    }
    selectedPurpose.forEach(element => {
      const index = completeBankPurposeList.findIndex((obj) => obj.lookupKey === element);
      // If the object is found, remove it from the array and update the variable
      if (index > -1)
        completeBankPurposeList.splice(index, 1);
    })
    this.filteredBankPurposeList[index] = completeBankPurposeList;
    // Log the updated array
    console.log("filter list of purpose after selection: ", this.filteredBankPurposeList);
    console.log("bank Data List check: ", this.bankDataList)
  }

  filterPurposeList(){
    console.log(" received payee list: ", this.payeeList)
    if (this.payeeList && Array.isArray(this.payeeList)) {
      this.payeeList.forEach((element, index) => {
        this.filteredBankPurposeList[index] = this.commonUtilty.deepCopy(this.bankPurposeCd)
      })
    }
  }

  filteredBankPurposeList = [];
  bankPurposeCd = [
    {
        "lookupKey": "autoDebt",
        "lookupValue": "Auto Debt",
        "sortOrder": 1,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "refundPremium",
        "lookupValue": "Refund Premium",
        "sortOrder": 3,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "claimPayment",
        "lookupValue": "Claim Payment",
        "sortOrder": 2,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    }
]
}

